import React, { useEffect, useState } from "react";
import Card from "../../Components/share/cards/Card";
import EmptyPic from "../../Assets/Image/png/empty.png";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import { Modal } from "../../Components/share/modal/Modal";
import AdminPriorityModal from "../../Components/layouts/AdminDashboard/AdminPriorityModal";
import IdeaInPriority from "../../Components/layouts/AdminDashboard/IdeaInPriority";
import DashCard from "../../Components/share/cards/DashCard";
import { ReactComponent as Trash } from "../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../Assets/Image/svg/addSession.svg";
import useFetch from "../../Hooks/useFetch";
import moment from "jalali-moment";

function AdminPriority() {
    // Todo This should removed
    const id = 11;
    // todo -----------------
    const [show, setShow] = useState(false);
    const [priority, setPriority] = useState({});
    const [displayPriorityUsers, setDisplayPriorityUsers] = useState(false);
    const [priorityInfo, setPriorityInfo] = useState({
        start: "",
        end: "",
    });

    const getPriorityService = useFetch({
        method: "GET",
        url: `BootCampIdeasPriorityService/${id}/ideasPriority`,
        noHeader: false,
        trigger: true,
        setter: (data) => {
            setPriority(data.results.at(0));
        },
    });
    const deletePriority = useFetch({
        method: "DELETE",
        url: `BootCampIdeasPriorityService/${priority?.id}`,
        noHeader: false,
        trigger: false,

        caller: getPriorityService,
    });

    const displayTime = (time) => {
        if (!!time) {
            return moment(time)
                .locale("fa")
                .format("ddd DD MMMM YYYY [ساعت] HH:mm");
        }
    };

    const handleDeletePriority = () => {
        deletePriority.reFetch();
    };

    return (
        <div>
            {displayPriorityUsers ? (
                <div>
                    <IdeaInPriority idPriority={priority?.id} />
                </div>
            ) : !priority ? (
                <div>
                    <Card>
                        <div className=" pt-20 pb-24 px-[20rem] flex flex-col justify-center items-center mt-[5rem]">
                            <h3 className="font-bold text-[1.6rem] text-purple-dark mb-20">
                                اطلاعات اولویت‌های بوت کمپ
                            </h3>
                            <div className="mb-4">
                                <img src={EmptyPic} alt="EmptyPic" />
                            </div>
                            <p className=" text-[1.8rem] mb-14">
                                با نمایش لیست ایده ها به افراد بوت کمپ، آنها
                                میتوانند 4 اولویت اول خود را در بین ایده ها مشخص
                                کنند
                            </p>
                            <BtnPrimary
                                text="فعالسازی لیست ایده ها برای افراد بوت کمپ"
                                className=" py-11 px-[7.8rem]"
                                onClick={() => setShow(true)}
                            />
                        </div>
                    </Card>
                </div>
            ) : (
                <div>
                    <div className=" flex SupportTicket__header justify-between items-center mt-[5rem]">
                        <h3 className=" text-[#77498F] text-[1.6rem] font-bold">
                            اطلاعات اولویت های بوت کمپ
                        </h3>
                    </div>
                    <DashCard className="flex pt-[1.6rem] pb-[8.1rem] px-[1.6rem] flex-col mt-[4.5rem] w-11/12 mr-[0.4rem] mb-[5.6rem] shadow-btn bg-[#FBF7FF]">
                        <div className=" grid grid-cols-[1fr_1fr_0.25fr] gap-y-[1rem] gap-x-[2rem] items-center  justify-start">
                            <p className=" text-gray font-normal text-[1.8rem] leading-[3.2rem]  ">
                                زمان فعال شدن اولویت دهی:
                            </p>
                            <p className=" text-[#000000] font-normal text-[1.8rem] leading-[3.2rem]">
                                {displayTime(priority.priority_start_time)}
                            </p>
                            <div className="flex justify-around">
                                <div
                                    className="flex flex-col cursor-pointer"
                                    onClick={() =>
                                        setDisplayPriorityUsers(true)
                                    }
                                >
                                    <Add />
                                </div>
                                <div
                                    className="flex flex-col justify-center items-center cursor-pointer"
                                    onClick={() => handleDeletePriority()}
                                >
                                    <Trash />
                                </div>

                                <div
                                    className="flex flex-col cursor-pointer"
                                    onClick={() => setShow(true)}
                                >
                                    <Edit />
                                </div>
                            </div>
                            <p className=" text-gray font-normal text-[1.8rem] leading-[3.2rem] ">
                                زمان غیر فعال شدن اولویت دهی:
                            </p>
                            <p className=" text-[#000000] font-normal text-[1.8rem] leading-[3.2rem]">
                                {displayTime(priority.priority_end_time)}
                            </p>
                        </div>
                    </DashCard>
                </div>
            )}
            <Modal show={show}>
                <AdminPriorityModal
                    close={setShow}
                    bootcampId={id}
                    getPriorityService={getPriorityService}
                    priority={priority}
                />
            </Modal>
        </div>
    );
}

export default AdminPriority;
